/* global $:true */
import ally from 'ally.js';

$(document).ready(() => {
	ally.style.focusSource();
});



// WEBPACK FOOTER //
// ./client/src/scripts/modules/a11y/index.js